__webpack_require__.p = "/shoppingreact/";